import { NgClass } from "@angular/common";
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SvgIconComponent } from "./svg-icon.component";

@Component({
    selector: "searchable-dropdown-list",
    imports: [NgClass, SvgIconComponent],
    templateUrl: "./searchable-dropdown-list.component.html"
})
export class SearchableDropdownListComponent {
    @Input({ required: true }) public keys!: string[];
    @Input({ required: true }) public values!: string[];
    @Input() public placeholder?: string;
    @Input() public dark: boolean = false;

    @Output() onSelect: EventEmitter<DropdownKeyValue> = new EventEmitter();

    public readonly isOpenSvgIcon: SvgIcon = SvgIcon.ChevronUp;
    public readonly isClosedSvgIcon: SvgIcon = SvgIcon.ChevronDown;

    public isOpen: boolean = false;
    public visibleItems: DropdownKeyValue[] = [];
    private filter?: string;

    public constructor(private selfRef: ElementRef) {

    }

    public ngOnChanges(): void {
        this.resetItems();
    }

    private resetItems(): void {
        this.visibleItems = [];
        
        for (let i = 0; i < Math.min(this.keys.length, this.values.length); ++i) {
            if (!this.filter?.length || this.keys[i].toLowerCase().indexOf(this.filter!) >= 0) {
                this.visibleItems.push({ key: this.keys[i], value: this.values[i] });
            }
        }
    }
    
    // -------------------------------------------------------------------------------------
    // Global Events
    // -------------------------------------------------------------------------------------

    @HostListener("document:mousedown", ["$event"])
    private onGlobalMouseDown(event: MouseEvent): void {
        if (this.isOpen && !this.selfRef.nativeElement.contains(event.target as HTMLInputElement)) {
            this.isOpen = false;
        }
    }

    @HostListener("document:keydown.escape", ["$event"])
    private onEscapePressed(): void {
        this.isOpen = false;
    }

    // -------------------------------------------------------------------------------------
    // Local Events
    // -------------------------------------------------------------------------------------

    public onFilterChange(value: string): void {
        if (value.length == 0) {
            this.filter = undefined;
        } else {
            this.filter = value.toLowerCase().trim();
        }

        this.resetItems();
    }

    public onValueClicked(kvp: DropdownKeyValue): void {
        this.isOpen = false;
        this.onSelect.emit(kvp);
    }
}

export type DropdownKeyValue = {
    key: string,
    value: string
}